import { Button, H2, PrintButton, Text1 } from '../../../../components/shared'
import styles from './SectionHeader.module.scss'
import { Select } from '../../../../components/shared/Select'
import { FilterPeriods } from '../../../../store'
import { PeriodPicker } from '../../../../components'
import { IconDownload } from '../../../../assets'
import React from 'react'
import { SectionHeaderProps } from './SectionHeader.types'
import { statsPeriodOptions } from '../../StatisticsMainPage'
import cl from 'classnames'

const SectionHeaderComponent = (props: SectionHeaderProps) => {
  const {
    periodFilter,
    onPeriodFilterSelect,
    period,
    setPeriod,
    label,
    boldLabel,
    labelIcon: LabelIcon
  } = props

  return (
    <H2 bold={boldLabel} className={styles.header}>
      <div className={styles.alignCenter}>
        {LabelIcon && (
          <LabelIcon
            style={{
              marginRight: 10,
              fill: styles.primary
            }}
          />
        )}
        {label}
      </div>
      {(period || periodFilter) && (
        <div className={styles.headerButtons}>
          <div className={styles.periodFilterContainer}>
            <Text1>Period</Text1>
            <Select<FilterPeriods>
              className={styles.periodInput}
              options={statsPeriodOptions}
              value={periodFilter}
              onChange={onPeriodFilterSelect}
              noNoneOption
            />
          </div>
          <div className={styles.periodPickerContainer}>
            <PeriodPicker
              period={period}
              setPeriod={setPeriod}
              noIcon
              label=''
              size='mini'
              placeholder='Custom'
              className={styles.customPeriodPicker}
            />
            <div className={styles.headerButtons}>
              <Button preset='icon' title='download' disabled>
                <IconDownload fill={styles.primary} />
              </Button>
              <PrintButton />
            </div>
          </div>
        </div>
      )}
    </H2>
  )
}

const SectionHeader = SectionHeaderComponent
export { SectionHeader }
